import { Link } from 'react-router-dom';
import { PiArrowRightBold, PiFileArrowDownDuotone, PiStudentDuotone } from 'react-icons/pi';

import ContentPageLayout from 'components/ContentPageLayout';

const documents = [
    {
        title: 'Adatkezelési tájékoztató diákoknak',
        description: 'A weboldal, a mobilalkalmazások és a Fürge Diák szolgáltatásait igénybe vevő diákok számára.',
        to: '/adatkezelési-tájékoztató-diákoknak',
        icon: <PiStudentDuotone />,
        external: false,
    },
    {
        title: 'Adatkezelési tájékoztató vállalati kapcsolattartóknak',
        description: 'A vállalati partnerek és kapcsolattartók adatkezelésére vonatkozó dokumentum.',
        to: '/assets/files/DataManagementInfo.pdf',
        icon: <PiFileArrowDownDuotone />,
        external: true,
    },
];

export default function DataManagementPage() {
    return (
        <ContentPageLayout
            title="Adatkezelés"
            subTitle="Adatkezelési tájékoztatók és felhasználási feltételek egy helyen."
            contentClassName="max-w-4xl"
        >
            <div className="grid gap-4 md:gap-5">
                {documents.map((document) => (
                    <Link
                        key={document.title}
                        to={document.to}
                        target={document.external ? '_blank' : undefined}
                        rel={document.external ? 'noopener noreferrer' : undefined}
                        className="content-card-link group flex items-center gap-4 rounded-2xl border border-neutral-200 bg-neutral-50 p-4 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-green-200 hover:bg-green-50 hover:shadow-lg sm:p-5"
                    >
                        <span className="gradient-green flex size-12 shrink-0 items-center justify-center rounded-xl text-2xl text-white shadow-md sm:size-14">
                            {document.icon}
                        </span>
                        <span className="min-w-0 flex-1">
                            <strong className="block font-display text-lg font-black leading-tight text-neutral-900 sm:text-xl">
                                {document.title}
                            </strong>
                            <span className="mt-1 block text-sm font-normal leading-relaxed text-neutral-600">
                                {document.description}
                            </span>
                        </span>
                        <PiArrowRightBold className="size-5 shrink-0 text-green-600 transition group-hover:translate-x-1" />
                    </Link>
                ))}
            </div>
        </ContentPageLayout>
    );
}
